import React from 'react'
import { Typography } from '@mui/material'

const PostAttributeTable = () => {
  return (
    <React.Fragment>
      <Typography variant="body2" align="center" sx={{ my: 4 }}>
       POST module is not ready for the competition system yet.
      </Typography>
    </React.Fragment>
  )
}

export default PostAttributeTable
